import { getCookieValue } from '@at/sauron-platform-core/lib/app/cookie.utils';
import { CookieEnum } from '@at/sauron-platform-core/lib/hooks/cookie.hook';
export const isUserInTestGroupsContext = (testGroups = '', bucket) => {
    return !!(testGroups && testGroups.split('-').find((testBucket) => testBucket === bucket));
};
export const isUserInTestBucket = (bucket) => {
    var _a;
    const cookieValue = getCookieValue(CookieEnum.AB_TEST_GROUPS_NAME);
    if (cookieValue) {
        return !!(cookieValue && cookieValue.split('-').includes(bucket));
    }
    if (typeof window === 'undefined') {
        // eslint-disable-next-line no-console
        console.error(`window is undefined, this util should only be run in the browser`);
        return false;
    }
    if (window === null || window === void 0 ? void 0 : window.abTestGroups) {
        return !!((_a = window === null || window === void 0 ? void 0 : window.abTestGroups) === null || _a === void 0 ? void 0 : _a.split('-').filter((testBucket) => testBucket === bucket).length);
    }
    return false;
};
